
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.0368 11.935C25.049 11.846 25.049 11.7557 25.0368 11.6667C25.0368 9.4115 23.2087 7.58333 20.9535 7.58333H15.7502C15.1058 7.58333 14.5835 7.061 14.5835 6.41667C14.5835 5.64312 14.2762 4.90125 13.7292 4.35427C13.1822 3.80729 12.4404 3.5 11.6668 3.5H6.7085C4.29225 3.5 2.3335 5.45875 2.3335 7.875V21.0233C2.35262 22.7835 3.7816 24.2021 5.54183 24.2083H20.3118C21.6346 24.2024 22.8192 23.388 23.2985 22.155L25.7368 14.5717C25.9057 13.6325 25.6493 12.6667 25.0368 11.935ZM4.0835 7.875C4.0835 6.42525 5.25875 5.25 6.7085 5.25H11.6668C12.3112 5.25 12.8335 5.77233 12.8335 6.41667C12.8399 8.02484 14.142 9.32694 15.7502 9.33333H21.0002C21.9694 9.3332 22.8378 9.93225 23.1818 10.8383C22.98 10.8208 22.777 10.8208 22.5752 10.8383H8.34183C6.99765 10.8387 5.79618 11.6769 5.33183 12.9383L4.0835 16.1817V7.875ZM20.3118 22.4583C20.903 22.4576 21.4342 22.0973 21.6535 21.5483L24.0802 14.14C24.1244 13.7469 24.0016 13.3533 23.7418 13.055C23.4512 12.7154 23.0219 12.5265 22.5752 12.5417H8.34183C7.72826 12.542 7.17943 12.9234 6.96516 13.4983L4.0835 21.14C4.16105 21.8877 4.79015 22.4564 5.54183 22.4583H20.3118Z","fill":"currentColor"}})])
          )
        }
      }
    